import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { legacyFallbackRoute } from '@jira/router-routes__legacy-fallback-routes/src/legacyFallbackRoute.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyFallbackRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	legacyFallbackRoute,
	() => ({
		layout: globalLayout,
		entryPoint: () => pageEntryPoint,
	}),
);
